import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
export var arrowKeyCodes = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
export function isArrowKey(keyCode) {
  return Object.values(arrowKeyCodes).includes(keyCode);
}
export function filterIntegerKey(evt) {
  evt = evt ? evt : window.event;
  var expect = getFinalInput(evt);
  if (!/^[0-9]*$/.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}
export function filterDecimalKey(evt) {
  evt = evt ? evt : window.event;
  var expect = getFinalInput(evt);
  if (!/^[0-9,.]*$/.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}
export function filterDecimalKeyAllowNegative(evt) {
  evt = evt ? evt : window.event;
  var expect = getFinalInput(evt);
  if (!/^[0-9,.-]*$/.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}
export function filterDecimal2digitsKey(evt) {
  evt = evt ? evt : window.event;
  var expect = getFinalInput(evt);
  if (!/^[0-9,.]*$/.test(expect)) {
    evt.preventDefault();
    return;
  }
  var decimalMatch = expect.match(/[.,](\d*)$/);
  if (decimalMatch && decimalMatch[1].length > 2) {
    evt.preventDefault();
    return;
  }
  return true;
}
export function filterDecimal2digitsKeyAllowNegative(evt) {
  evt = evt ? evt : window.event;
  var expect = getFinalInput(evt);
  if (!/^[0-9,.-]*$/.test(expect)) {
    evt.preventDefault();
    return;
  }
  var decimalMatch = expect.match(/[.,](\d*)$/);
  if (decimalMatch && decimalMatch[1].length > 2) {
    evt.preventDefault();
    return;
  }
  return true;
}
function getFinalInput(evt) {
  var target = evt.target;
  var expect;
  if (target && typeof target.selectionStart === "number") {
    //when input.type == "text", manage perfectly the future value of input
    var cursorStart = target.selectionStart;
    var cursorEnd = target.selectionEnd;
    var value = target.value;
    expect = value.slice(0, cursorStart) + evt.key + value.slice(cursorEnd);
  } else {
    // Ex: input.type="number", manage as the new char typed is added to the end of the existing value
    expect = target.value.toString() + evt.key.toString();
  }
  return expect;
}